import { COVERGO_SAAS_DEV, COVERGO_EU_UAT, COVERGO_ASIA_QA, COVERGO_EU_PROD } from "../consts.js"



export const medisky_dev = {
	"medisky-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "medisky_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV,
		featureFlags: {
			filesExplorer: {
				enableDownloadAsZip: true
			}
		}
	}
}

export const medisky_uat = {
	"medisky-studio.uat.eu.covergo.cloud": {
		appConfig: {
			tenantId: "medisky_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_EU_UAT,
		fileSystem: {
			bucketName: "covergo-euce1-uat-medisky-uat"
		},
		featureFlags: {
			filesExplorer: {
				enableDownloadAsZip: true
			}
		}
	},
}

export const medisky_qa = {
	"medisky-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "medisky_qa",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-medisky-qa"
		},
		featureFlags: {
			filesExplorer: {
				enableDownloadAsZip: true
			}
		}
	},
}

export const medisky_prod = {
	"medisky-studio.eu.covergo.com": {
		appConfig: {
			tenantId: "medisky_prod",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_EU_PROD,
		fileSystem: {
			bucketName: "covergo-euce1-prod-medisky"
		},
		featureFlags: {
			filesExplorer: {
				enableDownloadAsZip: true
			}
		}
	}
}


